<template>
    <div v-if="chat" class="chatroom-wrapper">
        <div
            v-if="isLogin && !chat.isOpen"
            class="floating-chatroom-access"
            :class="{ 'hang-on-right': isNeedHangOnRight }"
        >
            <div class="chat-box" @click="toggleChatroomVisibility">
                <span v-if="totalNewNotification" class="notif-span">
                    <a-badge :count="totalNewNotification" />
                </span>
                <admin-chat-svg />
                <h5 class="chat-text">Chat with Customers</h5>
            </div>
        </div>
        <floating-chatroom
            v-if="chat.isOpen"
            @close="toggleChatroomVisibility"
        />
    </div>
</template>

<script>
/* libraries */
import { mapState } from 'vuex';
import userNotificationApi from 'libs/user-notification';
import adminChatSvg from 'svg/admin-chat.svg';

/* libraries */
import errorPrinter from 'mixins/errorPrinter';
import AdminMixin from 'mixins/admin';
import AudioMixin from 'mixins/audio';
import adminNotificationMixin from 'mixins/adminNotificationMixin';
import messages from './locale';
import FloatingChatroom from './FloatingChatroom.vue';

export default {
    name: 'FloatingChatroomAccess',
    i18n: { messages },
    mixins: [errorPrinter, AdminMixin, AudioMixin, adminNotificationMixin],
    data: () => ({
        isLogin: false,
        totalNewNotification: 0
    }),
    components: {
        FloatingChatroom,
        adminChatSvg
    },
    computed: {
        ...mapState(['chat']),
        isNeedHangOnRight() {
            const pathName = window.location.pathname;

            let isMatchKeyword = false;

            const whitelistedKeywords = ['aaa', 'bbb'];

            for (let index = 0; index < whitelistedKeywords.length; index++) {
                const keyword = whitelistedKeywords[index];
                if (pathName.includes(keyword)) isMatchKeyword = true;
            }

            return isMatchKeyword;
        }
    },
    watch: {
        chat: {
            handler: function(val) {
                if (!val.isOpen) {
                    this.getTotalUserNotificationCount();
                }
            },
            deep: true
        }
    },
    mounted() {
        this.isLogin = this._alreadyLogin();
        this.checkIfAccessTokenExist();
        this.getTotalUserNotificationCount();
    },
    methods: {
        checkIfAccessTokenExist() {
            let token = localStorage.getItem('accessToken');
            if (token !== null) {
                this.isLogin = true;
            }
        },
        toggleChatroomVisibility() {
            if (this.chat && this.chat.isOpen) {
                this.$store.dispatch('chat/closeFloatingChatroom');
            } else {
                this.$store.dispatch('chat/openFloatingChatroom');
            }
        },
        async getTotalUserNotificationCount() {
            const data = await userNotificationApi.countNotifByNonNullAdminId(
                'from_admin.care_message.received_by_[USER_ID].*'
            );
            this.totalNewNotification = data.data.total;
        },
        onAdminNotification() {
            this.getTotalUserNotificationCount();
        }
    }
};
</script>

<style scoped lang="scss">
.floating-chatroom-access {
    position: fixed;
    width: '70px';
    bottom: 0;
    right: 42px;
    background-color: var(--NN0, #ffffff);
    height: 40px;
    box-sizing: content-box;
    min-width: 50px;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    border-bottom: 2px solid #009faa;
    border-right: none;
    box-shadow: rgba(141, 150, 170, 0.4) 0px 1px 4px;
    padding: 0;
    align-items: center;
    justify-content: center;
    border-right: 1px dashed var(--NN50, #f0f3f7);

    .chat-box {
        display: flex;
        padding: 12px;
        svg {
            fill: #8d96aa;
        }

        .chat-text {
            color: #8d96aa;
        }
    }

    .chat-box:hover {
        svg {
            fill: #009faa;
        }

        .chat-text {
            color: #009faa;
        }
    }

    cursor: pointer;

    .chat-text {
        margin: 0;
        padding-left: 5px;
        display: block;
        position: relative;
        font-weight: 700;
        font-family: 'Open Sauce One', 'Nunito Sans', -apple-system, sans-serif;
        font-size: 13px;
        line-height: 24px;
        letter-spacing: 0px;
        text-decoration: initial;
    }

    .notif-span {
        position: absolute;
        top: -7px;
        right: 140px;
    }
}

@media only screen and (min-device-width: 0px) and (max-device-width: 699px) {
    .hang-on-right {
        bottom: 120px;
        right: 0;
        border-bottom: none;
        border-right: 2px solid #009faa;
        border-radius: 8px 0 0 8px;
    }
}
</style>
